module.exports = require("next/dist/compiled/regenerator-runtime");
